import React from 'react';
import { AlignTextLeftButton, AlignTextCenterButton, AlignTextRightButton } from '@draft-js-plugins/buttons';

/* eslint-disable react/no-array-index-key */
function Alignment(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlignTextLeftButton, props), /*#__PURE__*/React.createElement(AlignTextCenterButton, props), /*#__PURE__*/React.createElement(AlignTextRightButton, props));
}

var alignmentStyles = {
  draftLeft: "d1sccg06",
  draftRight: "db0x715",
  draftCenter: "d1ti60k8"
};
var defaultTheme = {
  alignmentStyles: alignmentStyles
};

var index = (function (config) {
  if (config === void 0) {
    config = {};
  }
  var _config = config,
    _config$theme = _config.theme,
    theme = _config$theme === void 0 ? defaultTheme : _config$theme;
  var TextAlignment = function TextAlignment(props) {
    return /*#__PURE__*/React.createElement(Alignment, props);
  };
  var capitalFirstLetter = function capitalFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  var getBlockAlignment = function getBlockAlignment(block) {
    var style = 'left';
    block.findStyleRanges(function (value) {
      if (value.hasStyle('right')) style = 'right';
      if (value.hasStyle('center')) style = 'center';
      return true;
    }, function () {
      return true;
    });
    return capitalFirstLetter(style);
  };
  return {
    blockStyleFn: function blockStyleFn(block, _ref) {
      var getEditorState = _ref.getEditorState;
      var alignment = "draft" + getBlockAlignment(block);
      if (!block.getText()) {
        var previousBlock = getEditorState().getCurrentContent().getBlockBefore(block.getKey());
        if (previousBlock) {
          alignment = "draft" + getBlockAlignment(previousBlock);
        }
      }
      return theme.alignmentStyles[alignment];
    },
    TextAlignment: TextAlignment
  };
});

export { index as default };
